"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toArray;

function toArray(value) {
  return value == null ? [] : [].concat(value);
}